// 默认轮播图
export const defaultSlideShowList = [
    {
        coverPic: require("@/assets/banner.jpg")
    },
    {
        coverPic: require("@/assets/banner.jpg")
    },
    {
        coverPic: require("@/assets/banner.jpg")
    },
    {
        coverPic: require("@/assets/banner.jpg")
    },
    {
        coverPic: require("@/assets/banner.jpg")
    }
]; 